import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/HeaderRight/inform.png'


const _withScopeId = n => (_pushScopeId("data-v-089d87e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-right" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { class: "message" }
const _hoisted_5 = { class: "message" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "通知", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "消息", -1))
const _hoisted_10 = {
  key: 0,
  class: "point"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "el-dropdown-link" }
const _hoisted_13 = { class: "username" }

import MessageUtil from "@/utils/Message";
import messageOn from "@/assets/messageOn.png";
import messageOff from "@/assets/messageOff.png";
import { useStore } from "vuex";
import { toRefs, ref, computed, onMounted, watch, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserTools from "@/services/session/UserTools";

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderRight',
  props: {
  userRoleList: {
    type: Array,
  },
  userRoleIndex: {
    type: Number,
  },
  userMessage: {
    type: Object,
  },
},
  emits: ["updateUserRole"],
  setup(__props, { emit }) {

const props = __props;

const $store = useStore();
const router = useRouter();
const userList = UserTools.userRoles.roles;


const { userRoleList, userRoleIndex, userMessage } = toRefs(props);
console.log(userMessage);


const changeRole: (val: number) => void = (val: number): void => {
  emit("updateUserRole", val);
};
const List = ref([]);

const count = computed(() => {
  return List.value.filter((r) => r.status <= 2).length > 99
    ? 99
    : List.value.filter((r) => r.status <= 2).length;
});
const MessageState = computed(() => {
  return count.value > 0;
});
const route = useRoute();
watch(route, async () => {
  List.value = [
    ...List.value.filter((r) => router.currentRoute.value.query.rid !== r.rid),
  ];
});
onMounted(() => {
  $store.commit("message/updateState", Notification.permission === "granted");
  MessageUtil.getMessage(List.value);
});
onUnmounted(() => {
  List.value = [];
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_unref(userList)[_unref(userRoleIndex)].enterpriseInfo?.entityName || ""), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_tooltip, {
            class: "item",
            effect: "dark",
            content: 
              _unref($store).state.message.state
                ? '律师需求推送已开启!'
                : '您将无法实时获取到实时需求通知,如需推送请浏览器手动给予通知权限!'
            ,
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _unref($store).state.message.state ? _unref(messageOn) : _unref(messageOff),
                  alt: ""
                }, null, 8, _hoisted_6),
                _hoisted_7
              ])
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _createElementVNode("div", {
          class: "message margin",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/layout/message')))
        }, [
          _hoisted_8,
          _hoisted_9,
          (_unref(count) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_unref(MessageState))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(count)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_dropdown, { trigger: "click" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userRoleList), (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    "default-active": _unref(userRoleIndex),
                    key: index,
                    onClick: ($event: any) => (changeRole(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["default-active", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_el_avatar, {
                size: 35,
                src: _unref(userMessage).logo
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(UserTools).getUserName() || "尚未登录"), 1)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})